import { connect } from "react-redux";
import { useEffect, useState } from "react";

import { __Lang } from "../../../_core/core"; 

/* interface DrawActionsInterface {
  actionSuffle: Function;
  actionClear: Function;
} */

const DrawActions = (_props: any) => {
  //actionSuffle, actionClear 
  const [ isDisabled, setIsDisabled ] = useState<boolean>(false);

  useEffect(() => {
    if(_props.GAMEPLAY.currentTicket || _props.GAMEPLAY.drawStart) {
      setIsDisabled(true);
    }else {
      setIsDisabled(false);
    }
  }, [_props.GAMEPLAY.currentTicket, _props.GAMEPLAY.drawStart])

  return (
    <div className="draw__actions">
      <div className="button-container">
        {
          _props.GAMEPLAY.currentTicket ? (
            <button 
              onClick={ () => _props.actionNewCard() } 
              className="btn-weird blue actions_btn" 
              data-id="shuffle" 
              disabled={ _props.GAMEPLAY.drawStart || _props.GAMEPLAY.timer <= 0 }
              type="button">
              { __Lang.translate('n:play.newCard') }
          </button>
          ) : (
            <button 
              onClick={ () => _props.actionSuffle() }
              disabled={ isDisabled }
              className="btn-weird blue actions_btn" 
              data-id="shuffle" 
              type="button">
              { __Lang.translate('n:play.shuffle') }
            </button>
          )
        }
       
        <button 
          onClick={ () => _props.actionClear() }
          disabled={ isDisabled }
          className="btn-weird actions_btn" 
          data-id="pick-my-own" 
          type="button">
          { __Lang.translate('n:play.clear') }</button>
      </div>
    </div>
  )
}
 
const mapStateToProps = (state: any) => {
  return { 
    GAMEPLAY: state.game.GAMEPLAY, 
    STATUS_DATA: state.game.STATUS_DATA,
  };
}

export default connect(mapStateToProps, {})(DrawActions);